<template>
	<v-list class="user_chooseBox">
        <v-list-item-group>
          <!--개인-->
          <v-list-item data-tooltip-text="개인"
          @click="changeRoute(0)">
            <template v-slot:default="{ active, }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                  color="primary"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-avatar class="user_pic_s pp">
                <v-img :src="UserImgUrl"></v-img>
              </v-list-item-avatar>
              <v-list-item-subtitle class="user_s_tt_name">{{ Name }}</v-list-item-subtitle>
            </template>
          </v-list-item>
          <!--/개인-->      
          <!--기업-->
          <v-list-item data-tooltip-text="기업"
						v-for="(item, i) in orgList"
						:key="i" @click="changeRoute(item.organizationSequence)">
            <template v-slot:default="{ active, }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                  color="primary"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-avatar class="user_pic_s cpn">
                <v-img :src="UserImgFile[i]"></v-img>
              </v-list-item-avatar>
              <v-list-item-subtitle class="user_s_tt_name">{{ item.organizationName }}</v-list-item-subtitle>
            </template>
          </v-list-item>
          <!--/기업-->
					<s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
        </v-list-item-group>
      </v-list>
			
</template>
<script>
import { getOrgList, updateMainOrg, removeMainOrg  } from '@/api/orgconfig'
import { getUserImgList } from '@/api/userImg'

export default {
  name: 'orgheader',
  components: {
  },
  props:{
    userName: String
  },
  filters: {
  },
  data () {
    return {
      atvSeq: 0,
      orgList: '',
      orgOption: [],
      orgSelect: '',
      orgImgs: '',
      Name: '',
      UserImgUrl:'',
      UserImgFile: []
    }
  },
  created () {
  },
  mounted () {
    this.getOrgList()
  },
  methods: { 
    sorgConfig() {
      // this.$router.push('/dashboard')
      this.$router.push({ name: "sorgConfig" })
    },
    getOrgList () {
			this.orgList = ""
      this.atvSeq = 0
      this.Name = this.userName
      getUserImgList(JSON.stringify({ chainAddress: this.$store.state.user.useraddr })).then(response => {
        if(response.rdata.userImg) {
          this.UserImgUrl = process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.userImg.imgSequence
        } else {
          this.UserImgUrl = ''
        }
      })
      getOrgList().then(response => {
				this.orgList = response.rdata.list
				if(this.orgList.length > 0) {
					this.atvSeq = response.rdata.atvSeq
				}
        for (var i = 0; i < this.orgList.length; i++) {
          if(response.rdata.imgList[i])
            this.UserImgFile.push(process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.imgList[i].imgSequence)
          else
            this.UserImgFile.push("")
        }
      })
    },
    changeRoute(seq) {
      if(seq !== 0) {
        this.$refs.loading.start('정보 변경 중')
        updateMainOrg({ organizationSequence: seq }).then(Response => {
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            location.reload()
            this.$refs.loading.end()
          } else {
            this.$refs.loading.end()
            var msg = ''
            if (Response.rdata === undefined) {
              msg = Response.message
            } else {
              msg = Response.rdata.message
            }
            this.$refs.confirm.open('alert', '정보 변경 실패', '정보 변경 실패 : ' + msg)
          }
        })
      }
      else {
        if(this.$store.state.user.orgaddr !== undefined && this.$store.state.user.orgaddr !== null)  {
          this.$refs.loading.start('정보 변경 중')
          removeMainOrg({ '': '' }).then(Response => {
            if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
              location.reload()
              this.$refs.loading.end()
            } else {
              this.$refs.loading.end()
              var msg = ''
              if (Response.rdata === undefined) {
                msg = Response.message
              } else {
                msg = Response.rdata.message
              }
              this.$refs.confirm.open('alert', '정보 변경 실패', '정보 변경 실패 : ' + msg)
            }
          })
        }
      }
    }
  },
}
</script>
<style scoped>
/*
	css-only-tooltip version 1.0.0
	ⓒ 2015 AHN JAE-HA http://github.com/eu81273
	MIT License
*/


[data-tooltip-text]:hover {
	position: relative;
}

[data-tooltip-text]:after {
	-webkit-transition: bottom .3s ease-in-out, opacity .3s ease-in-out;
	-moz-transition: bottom .3s ease-in-out, opacity .3s ease-in-out;
	transition: bottom .3s ease-in-out, opacity .3s ease-in-out;

	background-color: rgba(97, 97, 97, 0.9);

  -webkit-box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.4);
	-moz-box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.4);
	box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.4);
	
  -webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	
  color: #FFFFFF;
	font-size: 12px;
	padding: 3px 8px;
	position: absolute;
	width: auto;
	min-width: 0px;
  max-width: 300px;
  min-height:0;
	word-wrap: break-word;

	z-index: 9999;

	opacity: 0;
	left: -9999px;
  bottom: 0px;
	
	content: attr(data-tooltip-text);
}

[data-tooltip-text]:hover:after {
	bottom: 12px;
	left: 40px;
	opacity: 1;
}
</style>